<template>
    <div class="ag-cell-edit-wrapper">
        <div
            role="presentation"
            class="ag-cell-editor ag-labeled ag-label-align-left ag-text-field ag-input-field"
        >
            <div
                class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper"
                role="presentation"
            >
                <b-v-form-btn-label-control
                    ref="control"
                    :value="formattedValue"
                    class="ag-input-field-input ag-text-field-input dropdown-toggle-no-caret"
                >
                    <b-calendar
                        :value="value"
                        @input="handleValueChange"
                        @selected="handleValueSelect"
                        hide-header
						class="datepicker-cell-editor"
                    ></b-calendar>
                </b-v-form-btn-label-control> 
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import format from 'date-fns/format';
    import parseISO from 'date-fns/parseISO';
    import { BVFormBtnLabelControl } from 'bootstrap-vue/src/components/form-btn-label-control/bv-form-btn-label-control';

    export default {
        components: {
            BVFormBtnLabelControl,
        },
        data() {
            return {
                formattedValue: ''
            }
        },
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat']),
        },
        methods: {
            getValue() {
                return this.formattedValue;
            },
			isPopup() {
				return true;	
			},			
            handleValueChange(value) {
                this.$emit('input', value);
                this.formattedValue = !!value
                    ? format(parseISO(value), this.dateFormat)
                    : '';

            },
            handleValueSelect(value) {
                this.$nextTick(() => {
                    this.$refs.control.hide(true);
                    this.params.stopEditing();
                })
            }
        },
        created() {
            this.value = this.params.value;
            this.formattedValue = this.params.value;
			this.dateFormat = this.params.dateFormat ? this.params.dateFormat : this.userUnicodeDateFormat;
        },
        mounted() {
            this.$nextTick(() => {
                if (this.$refs.control) {
                    this.$refs.control.show(true);
                }
            });
        },
    };
</script>

<style scoped lang="scss">
    :deep(.b-form-btn-label-control) {
        border: 0 !important;
        transition: none !important;
        box-shadow: none !important;
	    -webkit-box-shadow: none !important;
	    -moz-box-shadow: none !important;
	    box-shadow: none !important;
    }

    :deep(.b-form-btn-label-control.form-control > label) {
        border: 0 !important;
        transition: none !important;
        box-shadow: none !important;
	    -webkit-box-shadow: none !important;
	    -moz-box-shadow: none !important;
	    box-shadow: none !important;
    }
	
	.datepicker-cell-editor {
		overflow-y: visible;
		z-index: 1000;
	}


    /*::v-deep .b-form-btn-label-control.form-control > .btn {*/
    /*    max-width: 0;*/
    /*}*/

    /*::v-deep .btn .b-icon.bi {*/
    /*    display:none !important;*/
    /*}*/

</style>